import {combineLatest} from 'rxjs';
import {filter, map, shareReplay} from 'rxjs/operators';
import {track} from '@/et';
import {ptConfig$} from '@/config';
import {woMsg$} from '@/raw/wo';
import type {CurrencyEntity, ws} from '@/types';

type WoMsg = ws.WOMsg;

const spotUser$ = woMsg$.pipe(
  filter((data: WoMsg) => !!data.users),
  shareReplay(1)
);

spotUser$.subscribe((msg) => {
  const {sequence, timestamp, type, users, version} = msg;
  track('wo_users_debug', {sequence, timestamp, type, content: users, version});
});

export const spotPTDiscountState$ = combineLatest([spotUser$, ptConfig$]).pipe(
  map(([data, ptConfig]: [WoMsg, CurrencyEntity]) => !!data.users.find((o) => o.discountWithCcy === ptConfig.code)),
  shareReplay(1)
);
